<script lang='ts'>
    interface Linkable {
        name: string;
        slug: string;
    }

    interface LinkableWithId extends Linkable {
        id: number;
    }

    export let locality: Linkable;
    export let sub_locality: LinkableWithId | null = null;
    export let building: Linkable | null = null;

    export let separator = '/';
</script>

{#if locality}
    <ol class='breadcrumb-nonresponsive text-sm mb-2 text-neutral-500'>
        <li class='crumb hover:underline hover:cursor-pointer'><a href='/buildings/{locality.slug}'>{locality.name}</a></li>
        {#if sub_locality}
            <li class='crumb-separator' aria-hidden>{separator}</li>
            {#if building}
                <li class='crumb hover:underline hover:cursor-pointer'><a
                    href='/buildings/{locality.slug}/{sub_locality.slug}-n{sub_locality.id}'>{sub_locality.name}</a>
                </li>
                <li class='crumb-separator' aria-hidden>{separator}</li>
                <li class='crumb'>{building.name}</li>
            {:else}
                <li class='crumb'>{sub_locality.name}</li>
            {/if}
        {/if}
    </ol>
{/if}

<style>
    .crumb:last-of-type {
        @apply font-bold;
    }
</style>